
import React from 'react';
import { CheckCircle, Loader2 } from 'lucide-react';
import { usePlanFeatures } from '@/hooks/useFeatures';

interface PlanFeaturesDisplayProps {
  planId: string;
  communityId: string;
}

const PlanFeaturesDisplay = ({ planId, communityId }: PlanFeaturesDisplayProps) => {
  const { data: planFeatures, isLoading: featuresLoading } = usePlanFeatures(planId, communityId);

  if (featuresLoading) {
    return (
      <div className="flex items-center justify-center py-4">
        <Loader2 className="h-4 w-4 animate-spin" />
      </div>
    );
  }

  if (!planFeatures) {
    return (
      <ul className="space-y-3 text-sm">
        <li className="flex items-start">
          <CheckCircle className="h-4 w-4 text-green-500 mr-3 mt-0.5 flex-shrink-0" />
          <span>Basic features included</span>
        </li>
      </ul>
    );
  }

  const { directFeatures, inheritedFromPlans } = planFeatures;

  return (
    <ul className="space-y-3 text-sm">
      {inheritedFromPlans && inheritedFromPlans.length > 0 && (
        <li className="flex items-start text-gray-600">
          <CheckCircle className="h-4 w-4 text-green-500 mr-3 mt-0.5 flex-shrink-0" />
          <span>Features from {inheritedFromPlans.join(', ')}</span>
        </li>
      )}
      
      {directFeatures && directFeatures.map((feature) => (
        <li key={feature.id} className="flex items-start">
          <CheckCircle className="h-4 w-4 text-green-500 mr-3 mt-0.5 flex-shrink-0" />
          <span>{feature.name}</span>
        </li>
      ))}

      {(!directFeatures || directFeatures.length === 0) && (!inheritedFromPlans || inheritedFromPlans.length === 0) && (
        <li className="flex items-start">
          <CheckCircle className="h-4 w-4 text-green-500 mr-3 mt-0.5 flex-shrink-0" />
          <span>Standard features included</span>
        </li>
      )}
    </ul>
  );
};

export default PlanFeaturesDisplay;
